import React, { PropsWithChildren } from 'react';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { AlertBase, IBaseAlertProps } from '../Alert/AlertBase';
import { IGutterAsMarginProps } from '../../fundamentals/spaces/space';
import { IAllowBodyStyleOverrideProps } from '../../common/interfaces';
import { STATUS_COLOURS } from '../../fundamentals/colours/variants';

export interface ICalloutProps extends Pick<IBaseAlertProps, 'title'>, IGutterAsMarginProps, IAllowBodyStyleOverrideProps {
  variant?: typeof STATUS_COLOURS.INFO | typeof STATUS_COLOURS.ERROR | typeof STATUS_COLOURS.WARNING;
}

export const Callout: React.FC<PropsWithChildren<ICalloutProps>> = ({ variant = STATUS_COLOURS.INFO, children, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'Callout');

  return (
    <AlertBase variant={variant} light {...rest} {...generateTestId()}>
      {children}
    </AlertBase>
  );
};
